import { handleActions } from 'redux-actions';
import u from 'updeep';
import * as actions from './homeActions';
import * as bookActions from './bookActions';

const initialState = {
  bannerImages: [],
  isFetchingBanners : false,
  isFetchingHome: false,
  editorsPick: {
    meta: {},
    results: []
  },
  newArrivals: {
    meta: {},
    results: []
  },
  mostRead: {
    meta: {},
    results: []
  },
  awardWinning: {
    meta: {},
    results: []
  },
  homeCards: [],

  blogPosts: [],
  isFetchingReco: false,
  recommendedStories: [],
  mostLoved: [],
  lists: [],
  statistics: {},
  profile: {},
  spotlightCards: [],
  trendingLanguages: [],
  isFetchingTrending: false,
  trendingStories: [],
  exploreLevel1: [],
  exploreLevel3: [],
  exploreCards: [],
  testimonialVideos: [],
  testimonialTitle: null,
  staticVideos: [],
  staticTitle: null,
  isFetchingClassResources: false,
  classResources: null,
  engagementData: {},
  readCount: 0,
  trendingThemes: [],
  isTrendingTheme: true,
  seoData: {
    title: 'Digital Library of Stories for Kids | Stories | Storyweaver'
  }
}

export default handleActions({
  [actions.fetchBannerImages]: (state, action) => u({
    isFetchingBanners: true,
  }, state),

  [actions.receiveBannerImages]: (state, action) => u({
    bannerImages: action.payload.data.bannerImages,
    isFetchingBanners: false
  }, state),

  [actions.fetchHome]: (state, action) => u({
    isFetchingHome: true
  }, state),

  [actions.receiveHome]: (state, action) => u({
    editorsPick: action.payload.data.editorsPick,
    newArrivals: action.payload.data.newArrivals,
    mostRead: action.payload.data.mostRead || {},
    awardWinning: action.payload.data.awardWinning,
    blogPosts: action.payload.data.blogPosts,
    statistics: action.payload.data.statistics,
    lists: action.payload.data.lists,
    isFetchingHome: false
  }, state),

  [actions.fetchRecommendations]: (state, action) => u({
    isFetchingReco: true
  }, state),

  [actions.receiveRecommendations]: (state, action) => u({
    recommendedStories: action.payload.data.recommendedStories,
    mostLoved : action.payload.data.most_loved_stories,
    isFetchingReco: false,
  }, state),

  [actions.popupOpened]: (state, action) => u({
    profile: action.payload
  }, state),

  [actions.bookRead]: (state, action) => u({
    profile: action.payload
  }, state),

  [bookActions.receiveBookAssets]: (state, action) => {
    const updatesList = {};

    if (state.statistics && state.statistics.readsCount) {
      updatesList.statistics = {
        readsCount: state.statistics.readsCount + 1
      }
    }

    return u(updatesList, state);
  },

  [actions.receiveCards]: (state, action) => u({
    homeCards: action.payload.cards
  }, state),

  [actions.receiveSpotlightCards]: (state, action) => u({
    spotlightCards: action.payload.data
  }, state),
  
  [actions.receiveTrendingLanguages]: (state, action) => u({
    trendingLanguages: action.payload.data.most_read_languages
  }, state),

  [actions.fetchTrendingStories]: (state, action) => u({
    isFetchingTrending: true,
  }, state),

  [actions.receiveTrendingStories]: (state, action) => u({
    isFetchingTrending: false,
    trendingStories: action.payload.data.trending_stories
  }, state),

  [actions.receiveExplorations]: (state, action) => u({
    exploreLevel1: action.payload.data.explore_1_and_2,
    exploreLevel3: action.payload.data.explore_3_and_4,
    exploreCards: action.payload.data.explore_cards,
    
  }, state),

  [actions.receiveTestimonials]: (state, action) => u({
    staticTitle: action.payload.data.static_video_heading,
    staticVideos: action.payload.data.static_videos,
    testimonialTitle: action.payload.data.testimonial_videos_heading,    
    testimonialVideos: action.payload.data.testimonial_videos,    
  }, state),

  [actions.fetchClassroomResource]: (state, action) => u({
    isFetchingClassResources: true,
  }, state),

  [actions.receiveClassroomResource]: (state, action) => u({
    isFetchingClassResources: false,
    classResources: action.payload.classroom_resources,
  }, state),
  
  [actions.receiveEngagementContent]: (state, action) => u({
      engagementData: action.payload.ok ? action.payload.data  : null ,
      readCount: action.payload.read_count
  }, state),

  [actions.receiveTrendingThemes]: (state, action) => u({
    trendingThemes: action.payload.data,
    isTrendingTheme: false,
  }, state),
  
  [actions.receiveSeoData]: (state, action) => u({
    seoData: action.payload.seodata,
  }, state),

}, initialState);



// WEBPACK FOOTER //
// ./src/redux/homeReducer.js